import api from "./api";

const EXTERNAL_API_BASE = "https://app.ordera.app/api/devices";

export default {
  /**
   * Get users for FCM notifications
   * @param {Object} params - Query parameters
   * @param {string} params.project - Project code
   * @param {string} params.row - Row type (restaurant/company)
   * @param {string} params.restaurant_ids - Restaurant IDs
   * @param {string} params.company_ids - Company IDs
   * @returns {Promise}
   */
  getUsers(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`${EXTERNAL_API_BASE}/get-users?${queryString}`);
  },

  /**
   * Send FCM notification
   * @param {Object} data - Notification data
   * @param {string} data.project - Project code
   * @param {Array} data.user_ids - Array of user IDs
   * @param {string} data.title - Notification title
   * @param {string} data.body - Notification body
   * @returns {Promise}
   */
  sendFcm(data) {
    return api.post(`${EXTERNAL_API_BASE}/send-fcm`, data);
  },
};
